<template>
    <div class="menu" :class="{ 'menu--show': visible }">
        <button type="button" class="close btn" aria-label="Close" @click="handleCloseButtonClicked">
            <slot name="close">&times;</slot>
        </button>
        <slot></slot>
    </div>
</template>

<script>
    import Responsive from '../mixins/responsive';

    export default {
        mixins: [Responsive],

        props: {
            target: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                visible: false,
            }
        },
        methods: {
            open() {
                this.visible = true;
                if(window.innerWidth < this.breakpoints.md) {
                    document.body.style.overflow = 'hidden';
                    document.body.style.height = `${window.innerHeight}px`;
                }
            },
            close() {
                this.visible = false;
                this.listenForClickOut = false;
                if(window.innerWidth < this.breakpoints.md) {
                    document.body.style.overflow = '';
                    document.body.style.height = ''
                }
            },
            toggle() {
                if(this.visible) { this.close(); }
                else { this.open(); }
            },
            handleCloseButtonClicked() {
                this.close();
            },
            handleClickOut(e) {
                const menuButton = document.querySelector(this.target);
                if(!this.$el.contains(e.target) && !menuButton.contains(e.target)) {
                    this.close();
                }
            },
        },
        created() {
            if(!document.querySelector(this.target)) {
                console.error('aca-menu: target not found');
            }
            document.addEventListener('click', this.handleClickOut);

            this.$root.$on('menu::toggle', this.toggle);
        },
        mounted() {
            [...this.$el.querySelectorAll('a')].forEach(link => link.addEventListener('click',this.close));
        },
        destroyed() {
            document.removeEventListener('click', this.handleClickOut);
        },
    }
</script>